import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { AuthenticationState } from './authentication.reducer';
import { Pagination, PayrollSubmissions } from './auth.models';

export const getLayoutState =
  createFeatureSelector<AuthenticationState>('auth');

const getPaginationData = (state: AuthenticationState): Pagination | null =>
  state.pagination;
const getIsLoading = (state: AuthenticationState): boolean => state.isLoading;

const getAgentPayrollSubmissions = (
  state: AuthenticationState
): PayrollSubmissions[] | null => state.payrollSubmissions;

const getAgentPayrollSubmissionDetails = (
  state: AuthenticationState
): PayrollSubmissions | null => state.payrollSubmissionDetails;

export const getUser = createSelector(
  getLayoutState,
  (state: AuthenticationState) => state.user
);

export const getisLoggedIn = createSelector(
  getLayoutState,
  (state: AuthenticationState) => state.isLoggedIn
);

export const getError = createSelector(
  getLayoutState,
  (state: AuthenticationState) => state.error
);

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(getLayoutState, getIsLoading);

export const selectPaginationData: MemoizedSelector<object, Pagination | null> =
  createSelector(getLayoutState, getPaginationData);

export const selectAgentPayrollSubmissions: MemoizedSelector<
  object,
  PayrollSubmissions[] | null
> = createSelector(getLayoutState, getAgentPayrollSubmissions);

export const selectAgentPayrollSubmissionDetails: MemoizedSelector<
  object,
  PayrollSubmissions | null
> = createSelector(getLayoutState, getAgentPayrollSubmissionDetails);
